const CONTAINER = '#home-design-filters';

/** Keep filter visits in Swup's history/lifecycle, but fetch only the listing. */
export function initHomeDesignFilters(swup) {
    const endpointFor = (url) => {
        const target = new URL(url, window.location.href);
        if (target.origin !== window.location.origin || target.pathname !== window.location.pathname) return null;
        return document.querySelector(CONTAINER)?.dataset.filterEndpoint || null;
    };

    // Hovering a filter pill must not start the expensive full-page render.
    swup.hooks.replace('page:preload', (visit, args, next) =>
        endpointFor(args.url) ? undefined : next(visit, args));

    swup.hooks.replace('page:load', async (visit, args, next) => {
        const endpoint = endpointFor(visit.to.url);
        if (!endpoint || visit.from.url.split('?')[0] !== visit.to.url.split('?')[0]
            || (args.options.method && args.options.method !== 'GET')) {
            return next(visit, args);
        }

        const controller = new AbortController();
        visit.filterController = controller;
        const timeout = setTimeout(() => controller.abort(), 10000);

        try {
            const url = new URL(endpoint, window.location.origin);
            url.search = new URL(visit.to.url, window.location.origin).search;
            const response = await fetch(url, {
                signal: controller.signal,
                headers: { Accept: 'text/html' },
            });
            if (!response.ok) throw new Error('Filter response failed');
            const incoming = new DOMParser().parseFromString(await response.text(), 'text/html');
            const listing = incoming.querySelector(CONTAINER);
            if (!listing) throw new Error('Filter container missing');

            // Preserve the current head/title for this same-path visit. A separate
            // document lets Swup and its plugins use their normal replacement flow.
            // Never put this partial document in Swup's full-page URL cache.
            incoming.head.replaceWith(document.head.cloneNode(true));
            incoming.body.dataset.namespace = document.body.dataset.namespace || '';
            visit.containers = [CONTAINER];
            visit.cache = { read: false, write: false };
            visit.isHomeDesignFilter = true;
            return { url: visit.to.url, html: incoming.documentElement.outerHTML };
        } catch (error) {
            if (visit.done) throw error;
            // Missing entry, older server, timeout or malformed response: Swup
            // falls back to the ordinary complete page at the public URL.
            return next(visit, args);
        } finally {
            clearTimeout(timeout);
            delete visit.filterController;
        }
    });

    swup.hooks.on('visit:abort', (visit) => visit.filterController?.abort());
}
